var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "header",
                  [
                    _c("Breadcrumb", {
                      attrs: { title: _vm.rowData && _vm.rowData.Description1 }
                    }),
                    _vm._v(" "),
                    _vm.showWorkFlow
                      ? _c("GetFormField", {
                          model: {
                            value: _vm.workFlowModel,
                            callback: function($$v) {
                              _vm.workFlowModel = $$v
                            },
                            expression: "workFlowModel"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "LocationModal",
                    attrs: {
                      id: "location-modal",
                      "hide-footer": "",
                      "hide-header": ""
                    }
                  },
                  [_c("NextLocation", { attrs: { Location: _vm.Location } })],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.customer.code")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData && _vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.customer.Model_CardTypeId")) + ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData && _vm.rowData.CardType
                          ? _vm.rowData.CardType.Label
                          : ""
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.customer.Model_StatusReasonId")) +
                        ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData && _vm.rowData.StatusReason
                          ? _vm.rowData.StatusReason.Label
                          : ""
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.customer.status")) + ":")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData && _vm.rowData.Status
                          ? _vm.rowData.Status.Label
                          : ""
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.Customer"), active: "" }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CommercialTitle,
                                "text",
                                "insert.customer.Model_CommercialTitle"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Description1,
                                "text",
                                "insert.customer.Model_Description1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.LicenseNumber,
                                "text",
                                "insert.customer.Model_LicenseNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TaxCustomerType,
                                "object",
                                "insert.customer.Model_TaxCustomerTypeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TaxOffice,
                                "text",
                                "insert.customer.Model_TaxOffice"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TaxNumber,
                                "text",
                                "insert.customer.Model_TaxNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Alias,
                                "text",
                                "insert.customer.Model_Alias"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TradeLicenseNumber,
                                "text",
                                "insert.customer.TradeLicenseNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BlockReason,
                                "object",
                                "insert.customer.Model_BlockReasonId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Type,
                                "object",
                                "insert.customer.Model_TypeId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerInvoiceType,
                                "object",
                                "insert.customer.Model_CustomerInvoiceTypeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerRegion5,
                                "object",
                                "insert.customer.Model_CustomerRegion5Id"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.MarketingRegion5,
                                "object",
                                "insert.customer.MarketingRegion5Id"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.RouteCode,
                                "text",
                                "insert.customer.RouteCode"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.LicenseValidDate,
                                "date",
                                "insert.customer.LicenseValidDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsBlocked,
                                "check",
                                "insert.customer.Model_IsBlocked"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsOrderChangeUnitary,
                                "check",
                                "insert.customer.IsOrderChangeUnitary"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsOrderChangeUnitary,
                                "check",
                                "insert.customer.UseEDispatch"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsWarehouseSale,
                                "check",
                                "insert.customer.IsWarehouseSale"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.UseEInvoice,
                                "check",
                                "insert.customer.Model_UseEInvoice"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.rowData.RecordTypeId === 4 &&
                        _vm.rowData.UpperCustomer != null
                          ? _c("div", [
                              _c("span", [
                                _c("i", { staticClass: "far fa-circle" }),
                                _vm._v(
                                  _vm._s(_vm.$t("insert.customer.mainOfBranch"))
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "/KeyAccount/" +
                                        _vm.rowData.UpperCustomer.DecimalValue
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.rowData.UpperCustomer.Code) +
                                        " - " +
                                        _vm._s(_vm.rowData.UpperCustomer.Label)
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.CustomerLocations") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-4 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.locationItems,
                                "detail-buttons": _vm.detailButtons
                              },
                              model: {
                                value: _vm.rowData.CustomerLocations,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "CustomerLocations",
                                    $$v
                                  )
                                },
                                expression: "rowData.CustomerLocations"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.CustomerClass") } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Category3,
                                "object",
                                "insert.customer.Model_Category3Id"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Category2,
                                "object",
                                "insert.customer.Model_Category2Id"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Category1,
                                "object",
                                "insert.customer.Model_Category1Id"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Group,
                                "object",
                                "insert.customer.Model_GroupId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Class,
                                "object",
                                "insert.customer.Model_ClassId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.SalesDocumentType,
                                "object",
                                "insert.customer.Model_SalesDocumentTypeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.OwnerType,
                                "object",
                                "insert.customer.Model_OwnerTypeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ClassProposal,
                                "object",
                                "insert.customer.Model_ClassProposalId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.SalesMethod,
                                "object",
                                "insert.customer.Model_SalesMethodId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Model_GeographicEnvironment,
                                "object",
                                "insert.customer.Model_GeographicEnvironmentId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TradeFocus,
                                "object",
                                "insert.customer.Model_TradeFocusId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.InvoiceCombineRule,
                                "object",
                                "insert.customer.Model_InvoiceCombineRuleId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ClassProposalReason,
                                "object",
                                "insert.customer.Model_ClassProposalReasonId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BackMarginGroup,
                                "object",
                                "insert.customer.Model_BackMarginGroupId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Kind,
                                "object",
                                "insert.customer.Model_KindId"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.rowData.RecordTypeId === 3
              ? _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("insert.customer.Branchs") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.customer.Branchs"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextInput", {
                                          attrs: { type: "text" },
                                          model: {
                                            value: _vm.searchValue,
                                            callback: function($$v) {
                                              _vm.searchValue = $$v
                                            },
                                            expression: "searchValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-table-simple",
                                  {
                                    attrs: {
                                      "current-page": _vm.currentPage,
                                      "per-page": 0,
                                      bordered: "",
                                      small: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.customer.BranchCode"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.customer.BranchName"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.customer.AuthorizedBranch"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("list.operations"))
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(_vm.branchs, function(b, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [
                                              _vm._v(_vm._s(b.Code))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(b.Description1))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.allBranchs != null
                                                    ? _vm.allBranchs.find(
                                                        function(x) {
                                                          return (
                                                            x.RecordId ===
                                                            b.BranchId
                                                          )
                                                        }
                                                      ).Description1
                                                    : ""
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-td",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/KeyAccount/" +
                                                        b.RecordId
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-arrow-right text-success"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.totalRowCount,
                                    "per-page": 20,
                                    "aria-controls": "searched-customer-list"
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.customer.CustomerFinancialInfo")
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PriceListCategory,
                                "object",
                                "insert.customer.Model_PriceListCategoryId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CreditLimit,
                                "text",
                                "insert.customer.Model_CreditLimit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.RiskLimit,
                                "text",
                                "insert.customer.Model_RiskLimit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CurrentCredit,
                                "text",
                                "insert.customer.Model_CurrentCredit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CurrentRisk,
                                "text",
                                "insert.customer.Model_CurrentRisk"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ReservedLimit,
                                "text",
                                "insert.customer.reservedLimit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.FinanceCode,
                                "text",
                                "insert.customer.Model_FinanceCode"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ZdebitAccountRemainder,
                                "text",
                                "insert.customer.ZdebitAccountRemainder"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ZcreditAccountRemainder,
                                "text",
                                "insert.customer.ZcreditAccountRemainder"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DiscountPercent1,
                                "text",
                                "insert.customer.Model_DiscountPercent1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DiscountPercent2,
                                "text",
                                "insert.customer.Model_DiscountPercent2"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.SapCustomerId,
                                "text",
                                "insert.customer.sapCustomerId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DeliveryDayParam,
                                "text",
                                "insert.customer.Model_DeliveryDayParam"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PaymentPeriod,
                                "text",
                                "insert.customer.Model_PaymentPeriod"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TCIBreak1,
                                "object",
                                "insert.customer.discountTci1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TCIBreak2,
                                "object",
                                "insert.customer.discountTci2"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.StatementDay,
                                "text",
                                "insert.customer.statementDay"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DefaultPaymentType,
                                "object",
                                "insert.customer.Model_DefaultPaymentTypeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.AllowOverLimit,
                                "check",
                                "insert.customer.Model_AllowOverLimit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.IsDirectDebit,
                                "check",
                                "insert.customer.isDirectDebit"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ManualInvoiceClosure,
                                "check",
                                "insert.customer.Model_ManualInvoiceClosure"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Statement,
                                "check",
                                "insert.customer.statement"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.customer.CustomerCreditHistories")
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.customerCreditHistoriesItems
                              },
                              model: {
                                value: _vm.rowData.CustomerCreditHistories,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "CustomerCreditHistories",
                                    $$v
                                  )
                                },
                                expression: "rowData.CustomerCreditHistories"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.CustomerPaymentTypes") }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.paymentTypesItems
                              },
                              model: {
                                value: _vm.rowData.CustomerPaymentTypes,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "CustomerPaymentTypes",
                                    $$v
                                  )
                                },
                                expression: "rowData.CustomerPaymentTypes"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.detail") } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TextField1,
                                "text",
                                "insert.customer.textField1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TextField2,
                                "text",
                                "insert.customer.textField2"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Barcode,
                                "text",
                                "insert.customer.barcode"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.HoldsAsset,
                                "text",
                                "insert.customer.holdAsset"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Contracted,
                                "text",
                                "insert.customer.contracted"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.customer.CustomerItemDiscountCrts")
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.customerDiscountsItems
                              },
                              model: {
                                value: _vm.rowData.CustomerItemDiscounts,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.rowData,
                                    "CustomerItemDiscounts",
                                    $$v
                                  )
                                },
                                expression: "rowData.CustomerItemDiscounts"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.tag") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.customerLabelItems
                              },
                              model: {
                                value: _vm.rowData.CustomerLabels,
                                callback: function($$v) {
                                  _vm.$set(_vm.rowData, "CustomerLabels", $$v)
                                },
                                expression: "rowData.CustomerLabels"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.ECustomerAliases") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("NextDetailPanel", {
                              attrs: {
                                type: "get",
                                items: _vm.eCustomerAliasesItems
                              },
                              model: {
                                value: _vm.rowData.ECustomerAliases,
                                callback: function($$v) {
                                  _vm.$set(_vm.rowData, "ECustomerAliases", $$v)
                                },
                                expression: "rowData.ECustomerAliases"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74c5cdb9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74c5cdb9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyAccount/get.vue
// module id = null
// module chunks = 